$('.helen-blog-parent').each(/** @this {Element} */ function () {
	const $main = $(this);
	$main.parent().css({'overflow': 'hidden'});
	const HelenBlogID = /** @type {string} */ ($main.attr('data-helen-blog-id'));

	Ajax({
		'scope': $main,
		'url': '/helen/blog/getpage',
		'data': {
			'HelenBlogID': HelenBlogID,
            'Step': $main.attr('data-helen-blog-step'),
            'Tag': URIHash.get('t'),
            'Category': URIHash.get('c'),
            'Author': URIHash.get('a'),
            'q': URIHash.get('q'),
		},
		'success': function (/** Object<string,?> */ data) {
            $main.html(data['content']);

            gtm(':helen.blog.load');

			const $parent = $main.find('.helen-blog-form-parent');

			const START = 0;

			const $doc = $(document);

			/**
			 * @param {number} s
			 */
			const Step = function (s) {
				$parent.removeClass('helen-blog-form-parent-start');
				switch (s) {
				case START:
					$parent.addClass('helen-blog-form-parent-start');
					$doc.trigger(':helen.blog.start');
					break;
				}
			};

			if ($parent.hasClass('helen-blog-form-parent-start')) {
				Step(START);
            }

            let /** number */ Page = typeof URIHash.get('p') !== 'undefined' ? Math.floor(Number(URIHash.get('p'))) : 0;

            const RegisterLinks = function () {
                $main.find('.helen-blog-page-link').on('click', /** @this {Element} */function () {
                    Page = parseInt($(this).attr('data-page'), 10);
                    GetBlogs();
                });

                $main.find('.helen-blog-previous-page-link').on('click', function () {
                    Page--;
                    GetBlogs();
                });

                $main.find('.helen-blog-next-page-link').on('click', function () {
                    Page++;
                    GetBlogs();
                });

                $main.find('.helen-blog-categories>.nav .nav-link').on('click', /** @this {Element} */function () {
                    const $this = $(this);
                    const c = $this.text().trim();
                    let hash = '';
                    if (c === 'All Posts') {
                        hash = '#';
                    } else {
                        hash = '#c=' + encodeURIComponent(c);
                    }

                    if (history.pushState) {
                        history.pushState(null, '', hash);
                    } else {
                        location.hash = hash;
                    }

                    GetBlogs();

                    return false;
                });
            };

            const GetBlogs = function () {
                const t = $main.find('.helen-blog-paging').offset().top;

                URIHash.set('p', String(Page));

                Ajax({
                    url: '/helen/blog/getpage',
                    data: {
                        'p': Page,
                        'Tag': URIHash.get('t'),
                        'Category': URIHash.get('c'),
                        'Author': URIHash.get('a'),
                        'q': URIHash.get('q'),
                        'HelenBlogID': HelenBlogID,
                    },
                    success: function (/** Object<string,*> */d) {
                        let l = 0;
                        const s = $(window).scrollTop();
                        const /** !jQuery */ $i = $main.html(/** @type {string} */(d['content'])).find('img');
                        const f = function () {
                            $(window).scrollTop(s - (t - $main.find('.helen-blog-paging').offset().top));
                        };
                        $i.on('load', function () {
                            if (++l === $i.length - 1) {
                                f();
                            }
                        });
                        f();

                        RegisterLinks();
                    }
                });
            };

            RegisterLinks();

		},
	});

});